import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {CustomFormsModule} from 'ng2-validation';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ResolverService} from './core/services/resolver.service';
import {AuthenticationModule} from './auth/auth.module';
import {AppComponent} from './app.component';
import {DefaultLayoutComponent} from './layout/default/default.layout.component';
import {routing} from './app.routing';
import {HttpService} from './core/services/http.service';
import {ValidatorMessageService} from './core/services/validator-message.service';
import {HttpModule} from '@angular/http';
import {CommonModule} from '@angular/common';

import {SearchCardComponent} from './home/search-card/search-card.component';
import {ResultSearchCardComponent} from './home/result-search-card/result-search-card.component';
import {HeaderComponent} from './layout/header/header.component';
import {FooterComponent} from './layout/footer/footer.component';
import {ErrorsComponent} from './core/components/errors/errors.component';
import {CardService} from './services/card.service';
import {
  AlertModule,
  BsDatepickerModule,
  BsDropdownModule,
  PaginationModule,
  ProgressbarModule,
  TabsModule,
  TypeaheadModule
} from 'ngx-bootstrap';
import {DragDropDirectiveModule} from 'angular4-drag-drop';
import {ToastrModule} from 'ngx-toastr';


import {defineLocale} from 'ngx-bootstrap/chronos';
import {enGbLocale} from 'ngx-bootstrap/locale';
import {ErrorService} from './core/services/error.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {WarehouseService} from './services/warehouse.service';
import {LanguageService} from './services/language.service';
import {CardConditionService} from './services/card-condition.service';
import {EditionService} from './services/edition.service';

import {CardStockDetailComponent} from './home/card-stock-detail/card-stock-detail.component';
import {CardStockService} from './services/card-stock.service';
import {PriceRuleComponent} from './conf/price-rule/price-rule.component';
import {PriceRuleService} from './services/price-rule.service';
import {PriceRuleAddComponent} from './conf/price-rule-add/price-rule-add.component';
import {PriceRuleDetailComponent} from './conf/price-rule-detail/price-rule-detail.component';
import {StockRuleComponent} from './conf/stock-rule/stock-rule.component';
import {StockRuleService} from './services/stock-rule.service';
import {StockRuleAddComponent} from './conf/stock-rule-add/stock-rule-add.component';
import {StockRuleDetailComponent} from './conf/stock-rule-detail/stock-rule-detail.component';
import {PriceRuleAddTableComponent} from './conf/price-rule-add-table/price-rule-add-table.component';
import {PriceRuleSetAddComponent} from './conf/price-rule-set-add/price-rule-set-add.component';
import {Ng4LoadingSpinnerModule} from 'ng4-loading-spinner';
import {ConfirmDirective} from './shared/confirm.directive';
import {ChartsModule} from 'ng2-charts';
import {StockInventoryComponent} from './conf/stock-inventory/stock-inventory.component';
import {StockInventoryService} from './services/stock-inventory.service';
import {BrandService} from './services/brand.service';
import {CategoryService} from './services/category.service';
import {CategoryStructureService} from './services/category-structure.service';
import {HoloService} from './services/holo.service';
import {RarityService} from './services/rarity.service';
import {ProductStructureService} from './services/product-structure.service';

defineLocale('en', enGbLocale);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    ErrorsComponent,
    DefaultLayoutComponent,
    FooterComponent,
    SearchCardComponent,
    HeaderComponent,
    ResultSearchCardComponent,
    CardStockDetailComponent,
    PriceRuleComponent,
    PriceRuleAddComponent,
    PriceRuleDetailComponent,
    StockRuleComponent,
    StockRuleAddComponent,
    StockRuleDetailComponent,
    PriceRuleAddTableComponent,
    PriceRuleSetAddComponent,
    ConfirmDirective,
    StockInventoryComponent
  ],
  imports: [
    ProgressbarModule.forRoot(),
    CommonModule,
    routing,
    BrowserModule,
    CustomFormsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthenticationModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    HttpModule,
    TypeaheadModule.forRoot(), TabsModule.forRoot(), AlertModule.forRoot(), BsDatepickerModule.forRoot(), PaginationModule.forRoot(), BsDropdownModule.forRoot(),
    DragDropDirectiveModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-full-width',
      preventDuplicates: true,
    }),
    Ng4LoadingSpinnerModule,
    ChartsModule
    // CardStockModule // Lazy
  ],
  providers: [
    ErrorService,
    ResolverService,
    HttpService,
    ValidatorMessageService,
    CardService,
    WarehouseService,
    LanguageService,
    CardConditionService,
    EditionService,
    CardStockService,
    PriceRuleService,
    StockRuleService,
    StockInventoryService,
    BrandService,
    CategoryService,
    CategoryStructureService,
    HoloService,
    RarityService,
    ProductStructureService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts